import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Table from "./OccupierTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faPlus, faSave, faUndo } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { PopupMessage } from "../../utils/utils";
import "bootstrap/dist/css/bootstrap.css";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import Popup from "reactjs-popup";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Select from "react-select";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class OccupierMaster extends React.Component {
  state = {
    id: undefined,
    url: `${apiUrl.apiUrl.url}/occupier/update-address-details`,
    occupierGroups: [],
    countries: [],
    states: [],
    districts: [],
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    delete: false,
    cities: [],
    correspondenceStates: [],
    correspondenceDistricts: [],
    correspondenceCities: [],
    companyName: [],
    redirect: false,
    initialValues: {
      groupId: "",
      companyName: "",
      companyCode: "",
      companyId: "",
      registeredAddress: "",
      registeredCountry: "",
      registeredState: "",
      registeredDistrict: "",
      registeredCity: "",
      registeredPincode: "",
      correspondenceAddress: "",
      correspondenceCountry: "",
      correspondenceState: "",
      correspondenceDistrict: "",
      correspondenceCity: "",
      correspondencePincode: "",
    },
  };
  groupId = "";
  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/occupier-group/fetch-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          occupierGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  changeGroup = (e) => {
    let groupid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/occupier/get-group-companies/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyName: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeCountry = (e) => {
    let countryid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + countryid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeCorrespondenceCountry = (e) => {
    let countryid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + countryid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          correspondenceStates: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeState = (e) => {
    let stateId = e.target.value;
    console.log(stateId, "SI");
    fetch(`${apiUrl.apiUrl.url}/districts/state-districts/` + stateId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          districts: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeCorrespondenceState = (e) => {
    let stateId = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/districts/state-districts/` + stateId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          correspondenceDistricts: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeDistrict = (e) => {
    let districtId = e.target.value;
    console.log(districtId, "SI");
    fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + districtId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          cities: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeCorrespondenceDistrict = (e) => {
    let districtId = e.target.value;
    console.log(districtId, "SI");
    fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + districtId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          correspondenceCities: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeCompany = (e) => {
    let groupid = e.value;
    this.state.initialValues.companyId = e.value;
    this.state.initialValues.companyName = e.label;
    //this.state.companyId = e.value;
    this.setState({})
    fetch(`${apiUrl.apiUrl.url}/occupier/get-company/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.id, "55");
        this.setState({
          initialValues: data.data,
          // countries: data.registeredCountry,
          states: data.registeredStates,
          districts: data.registeredDistricts,
          cities: data.registeredCities,
          correspondenceStates: data.correspondenceStates,
          correspondenceDistricts: data.correspondenceDistricts,
          correspondenceCities: data.correspondenceCities,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fillCorrespondenceAddress(e, values) {
    console.log(values, "val");
    values.correspondenceAddress = values.registeredAddress;
    this.state.correspondenceStates = this.state.states;
    this.state.correspondenceCities = this.state.cities;
    this.state.correspondenceDistricts = this.state.districts;
    values.correspondenceCountry = values.registeredCountry;
    values.correspondenceState = values.registeredState;
    values.correspondenceDistrict = values.registeredDistrict;
    values.correspondenceCity = values.registeredCity;
    values.correspondencePincode = values.registeredPincode;
    this.setState({});
  }

  constructor(props) {
    super(props);
    //this.state = {value: ''};
    //this.handleChange = this.handleChange.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/occupier/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        alert("Sorry you cannot delete this item");
      } else {
        // if (window.confirm("Delete the item?")) {
        //   axios({
        //     method: "get",
        //     url: `${apiUrl.apiUrl.url}/occupier/delete?id=${self.state.id}`,
        //   }).then(function (response) {
        //     if (!response.data.success) {
        //       alert("Something Went Wrong");
        //     } else {
        //       alert("Data Deleted Successfully");
        //       self.setState({ redirect: true });
        //     }
        //   });
        // }
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/occupier/create`,
          initialValues: {
            companyId: "",
            companyCode: "",
            companyType: "",
            companyPan: "",
            companyTan: "",
            groupId: "",
            groupName: "",
          },
        });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/occupier/get-company/?id=${this.props.match.params.id}`).then((response) =>{
          let data = response.data;
          var companies = [
            { id: data.data.companyId, company_name: data.data.companyName },
          ];
          athis.setState({
            url: `${apiUrl.apiUrl.url}/occupier/update-address-details?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            states: data.registeredStates,
            districts: data.registeredDistricts,
            cities: data.registeredCities,
            correspondenceStates: data.correspondenceStates,
            correspondenceDistricts: data.correspondenceDistricts,
            correspondenceCities: data.correspondenceCities,
            companyName: companies,
          });
        });

        // fetch(
        //   `${apiUrl.apiUrl.url}/occupier/get-company/?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     var companies = [
        //       { id: data.data.companyId, company_name: data.data.companyName },
        //     ];
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/occupier/update-address-details?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       states: data.registeredStates,
        //       districts: data.registeredDistricts,
        //       cities: data.registeredCities,
        //       correspondenceStates: data.correspondenceStates,
        //       correspondenceDistricts: data.correspondenceDistricts,
        //       correspondenceCities: data.correspondenceCities,
        //       companyName: companies,
        //     });
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        companyName: "",
        companyCode: "",
        registeredAddress: "",
        registeredCountry: "",
        registeredState: "",
        registeredDistrict: "",
        registeredCity: "",
        registeredPincode: "",
        correspondenceAddress: "",
        correspondenceCountry: "",
        correspondenceState: "",
        correspondenceDistrict: "",
        correspondenceCity: "",
        correspondencePincode: "",
      },
    });
  };

  redirectToDelete = () => {
    this.setState({
      delete: false,
    });
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/occupier/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        // alert("Something Went Wrong");
        self.setState({
          popupalertMessage: true,
          popupMessageContent: "Something Went Wrong",
        });
      } else {
        // alert("Data Deleted Successfully");
        self.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };
  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/occupier" />;
    }

    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/occupier-directory">Occupier Directory</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Occupier Address Details</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            var self = this;
            actions.setSubmitting(false);
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/occupier/update-address-details`,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!",
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (

            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off">
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      <div className="newGridSectionInner">
                        <label>Company Group <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="groupId"
                            onChange={(e) => {
                              this.changeGroup(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.occupierGroups.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.group_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage name="groupId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Occupier ID</label>
                        <div className="position-relative">
                          <Field type="text" name="companyCode" />
                          <ErrorMessage name="companyCode" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Company Name <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="companyId"
                            onChange={(e) => {
                              this.changeCompany(e);
                            }}
                            value={{
                              label: this.state.initialValues.companyName,
                              value: this.state.initialValues.companyId,
                            }}
                            options={this.state.companyName.map((item) => ({
                              label: item.company_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="companyId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="gridColOneByThree textWithHrTag">
                        <hr className="m-0 mt-1" />
                        <h4>Occupier Registered Address</h4>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Address <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field type="text" name="registeredAddress" />
                          <ErrorMessage name="registeredAddress" component="div" className="text-red" />
                        </div>
                      </div>


                      <div className="newGridSectionInner">
                        <label>Country <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="registeredCountry"
                            onChange={(e) => {
                              this.changeCountry(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.countries.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.country_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="registeredCountry"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>State <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="registeredState"
                            onChange={(e) => {
                              this.changeState(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.states.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.state_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="registeredState"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>District <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="registeredDistrict"
                            onChange={(e) => {
                              this.changeDistrict(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.districts.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.district_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="registeredDistrict"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>City <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="registeredCity"
                            onChange={handleChange}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.cities.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.city_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="registeredCity"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>PinCode <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field type="text" name="registeredPincode" />
                          <ErrorMessage
                            name="registeredPincode"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="gridColOneByThree textWithHrTag">
                        <hr className="m-0 mt-1" />
                        <div className="d-flex align-items-center gap-5 justify-content-start">
                          <h4>Occupier Correspondence Address</h4>
                          <label>
                            <Field
                              type="checkbox"
                              name="sameAsRegistered"
                              value="sameAsRegistered"
                              className="sameAs"
                              onClick={(e) => {
                                console.log("here");
                                this.fillCorrespondenceAddress(e, values);
                              }}
                            />
                            Same as Registered Address
                          </label>
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Address <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field type="text" name="correspondenceAddress" />
                          <ErrorMessage
                            name="correspondenceAddress"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>Country <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="correspondenceCountry"
                            onChange={(e) => {
                              this.changeCorrespondenceCountry(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.countries.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.country_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="correspondenceCountry"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>State <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="correspondenceState"
                            onChange={(e) => {
                              this.changeCorrespondenceState(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.correspondenceStates.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.state_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="correspondenceState"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>District <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="correspondenceDistrict"
                            onChange={(e) => {
                              this.changeCorrespondenceDistrict(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.correspondenceDistricts.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.district_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="correspondenceDistrict"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>City <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="correspondenceCity"
                            onChange={handleChange}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.correspondenceCities.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.city_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="correspondenceCity"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>PinCode <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field type="text" name="correspondencePincode" />
                          <ErrorMessage
                            name="correspondencePincode"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" disabled={isSubmitting} className="add_button">
                        Save
                      </button>
                      <button type="submit" disabled={isSubmitting} className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>

                </Form>
              </div>


              {/* <Form className="customTabs">
                <div className="unitFormContainer mt-5">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company Group <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="groupId"
                                onChange={(e) => {
                                  this.changeGroup(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.occupierGroups.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.group_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="groupId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Occupier ID
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="companyCode" />
                              <ErrorMessage
                                name="companyCode"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Company Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                                                            classNamePrefix="custom-select-style-inner"
                                name="companyId"
                                onChange={(e) => {
                                  this.changeCompany(e);
                                  //this.valueChange(e, "change_brand_type");
                                }}
                                // value={this.state.brandSelected}
                                value={{
                                  label: this.state.initialValues.companyName,
                                  value: this.state.initialValues.companyId,
                                }}
                                options={this.state.companyName.map((item) => ({
                                  label: item.company_name,
                                  value: item.id,
                                }))}
                              />
                              <Field
                              as="select"
                              name="companyId"
                              onChange={(e) => {
                                this.changeCompany(e);
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              {this.state.companyName.map((obj) => (
                                <option key={obj.id} value={obj.id}>
                                  {obj.company_name}
                                </option>
                              ))}
                            </Field>
                              <ErrorMessage
                                name="companyId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="unitFormContainer mt-0"
                  style={{ backgroundColor: "#d4d4d4" }}
                >
                  <div className="container">
                    <div className="row mb-4">
                      <div className="col-lg-12">
                        <h5 className="mb-4 addressHeading">
                          Occupier Registered Address
                        </h5>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Address <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="registeredAddress" />
                              <ErrorMessage
                                name="registeredAddress"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Country <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="registeredCountry"
                                onChange={(e) => {
                                  this.changeCountry(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.countries.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.country_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="registeredCountry"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              State <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="registeredState"
                                onChange={(e) => {
                                  this.changeState(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.states.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.state_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="registeredState"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              District <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="registeredDistrict"
                                onChange={(e) => {
                                  this.changeDistrict(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.districts.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.district_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="registeredDistrict"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              City <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="registeredCity"
                                onChange={handleChange}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.cities.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.city_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="registeredCity"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              PinCode <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="registeredPincode" />
                              <ErrorMessage
                                name="registeredPincode"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="unitFormContainer mt-0"
                  style={{ backgroundColor: "#e1e1e1" }}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <h5 className="mb-4 addressHeading">
                          Occupier Correspondence Address
                        </h5>
                      </div>
                      <div className="col-lg-12">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <div className="col-sm-12 text-center">
                              <div className="autoFillContainer">
                                <label>
                                  <Field
                                    type="checkbox"
                                    name="sameAsRegistered"
                                    value="sameAsRegistered"
                                    className="sameAs"
                                    onClick={(e) => {
                                      console.log("here");
                                      this.fillCorrespondenceAddress(e, values);
                                    }}
                                  />
                                  Same as Registered Address
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Address <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="correspondenceAddress" />
                              <ErrorMessage
                                name="correspondenceAddress"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Country <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="correspondenceCountry"
                                onChange={(e) => {
                                  this.changeCorrespondenceCountry(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.countries.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.country_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="correspondenceCountry"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              State <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="correspondenceState"
                                onChange={(e) => {
                                  this.changeCorrespondenceState(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.correspondenceStates.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.state_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="correspondenceState"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              District <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="correspondenceDistrict"
                                onChange={(e) => {
                                  this.changeCorrespondenceDistrict(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.correspondenceDistricts.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.district_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="correspondenceDistrict"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              City <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="correspondenceCity"
                                onChange={handleChange}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.correspondenceCities.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.city_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="correspondenceCity"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              PinCode <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="correspondencePincode" />
                              <ErrorMessage
                                name="correspondencePincode"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row" style={{ display: "block" }}>
                  <div className="col-lg-6 offset-lg-6">
                    <div className="btnContainer">
                      <div>
                        <button type="submit" disabled={isSubmitting}>
                          Save
                        </button>
                        <button type="submit" disabled={isSubmitting}>
                        Reset
                      </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Are you sure you want to delete this item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <Table />
      </>
    );
  }
}

export default withRouter(OccupierMaster);
